var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPTypeWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-wallet-5080230",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.005,
    height: 18.576,
    viewBox: "0 0 20.005 18.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44444",
    "data-name": "Path 44444",
    d: "M455.714,298.929a.715.715,0,1,0-.714-.715A.715.715,0,0,0,455.714,298.929Z",
    transform: "translate(-440.71 -287.497)",
    fill: "#300787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44445",
    "data-name": "Path 44445",
    d: "M121.433,55.358v-.714A2.143,2.143,0,0,0,119.29,52.5H107.143A2.143,2.143,0,0,0,105,54.643v14.29a2.143,2.143,0,0,0,2.143,2.143h15a2.143,2.143,0,0,0,2.143-2.143v-3.4a2.139,2.139,0,0,0,.714-1.6V62.5a2.139,2.139,0,0,0-.714-1.6V57.5a2.143,2.143,0,0,0-2.143-2.143Zm-15,.122a2.137,2.137,0,0,1,.714-.122H120v-.714a.715.715,0,0,0-.714-.714H107.143a.715.715,0,0,0-.714.714Zm10.717,7.737A2.858,2.858,0,0,0,120,66.075h2.858v2.858a.715.715,0,0,1-.714.714h-15a.715.715,0,0,1-.714-.714V57.5a.715.715,0,0,1,.714-.714h15a.715.715,0,0,1,.714.714v2.858H120A2.858,2.858,0,0,0,117.146,63.217ZM120,61.788a1.429,1.429,0,0,0,0,2.858h2.858a.715.715,0,0,0,.714-.714V62.5a.715.715,0,0,0-.714-.714Z",
    transform: "translate(-105 -52.5)",
    fill: "#300787",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPTypeWallet);
export default __webpack_public_path__ + "static/media/p_type_wallet.a7d6dd58e5c587d3eb49937f28d07998.svg";
export { ForwardRef as ReactComponent };